import { Col, Row, Tabs } from 'antd'
import { Navigator } from 'modules/core/components'
import { SiderLayout } from 'modules/core/layouts'
import { useTranslation } from 'react-i18next'
import { StatusConnection, UploadS3 } from './components'
import ProcessesList from 'modules/processes/containers/ProcessesList/ProcessesList'
import MonitorScreen from 'modules/monitor/Monitor'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { connect } from 'react-redux'
import login from 'modules/login'

const CREDENTIALS = 'credentials'
const MONITOR = 'monitor'
const PROCESSES = 'processes'
const UPLOADS3 = 'uploads3'

const IntegrationsHome = ({ loggedUser }) => {
  const enableOldS3 = useFeatureIsOn('enalbe-old-s3')
  let { type } = useParams()
  const [tabKey, setTabKey] = useState(type || CREDENTIALS)
  const { t } = useTranslation()

  const renderHeader = () => (
    <Navigator
      floated={false}
      size="big"
      items={[
        {
          name: t('LABEL_CONFIG'),
          url: `/configuracion`,
        },
        { name: t('LABEL_INTEGRATION') },
      ]}
    />
  )

  const handleClick = (key) => {
    setTabKey(key)
    window.history.replaceState(null, '', `/configuracion/integraciones/${key}`)
  }

  return (
    <SiderLayout>
      <Row gutter={[24, 24]}>
        <Col span={24}>{renderHeader()}</Col>
        <Col span={24}>
          <Tabs size="small" onChange={handleClick} defaultActiveKey={tabKey}>
            <Tabs.TabPane tab={t('INTEGRATIONS_CREDENTIALS_TAB_TITLE')} key={CREDENTIALS}>
              {/* <TableActions /> */}
              <StatusConnection />
            </Tabs.TabPane>
            {!enableOldS3 && loggedUser.link_upload_file && (
              <Tabs.TabPane tab="Carga s3" key={UPLOADS3}>
                <UploadS3 />
              </Tabs.TabPane>
            )}
            <Tabs.TabPane tab="Monitor" key={MONITOR}>
              <MonitorScreen />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t('LABEL_PROCESS_UPLOAD')} key={PROCESSES}>
              <ProcessesList />
            </Tabs.TabPane>
          </Tabs>
        </Col>
      </Row>
    </SiderLayout>
  )
}

const mapStateToProps = (state) => ({
  loggedUser: login.selectors.getWhoAmI(state),
})

export default connect(mapStateToProps, null)(IntegrationsHome)
